// DsOverline — implementa a classe `.sect` do canvas (DESIGN-SYSTEM.md §6.4), em 11
// artboards, mais a forma `xs` da `.navsub` quando ela é usada NO CORPO da página
// (ex. "VOLUME · CLIQUE ABRE A LISTA" no dte-dashboard).
//
// O `overline` do tema é 12px/700 uppercase sem tracking (`core/typography.ts:110-115`);
// §8-T4 o alinha ao `sm`. A `.navsub` de 10px/800 `.12em` que aparece em 117 artboards é o
// subheader da sidebar e pertence ao `nav-section` do layout, não a este componente.

import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

export type DsOverlineProps = {
  children: React.ReactNode;
  /** Padrão: 'sm' (`.sect`). 'xs' é a forma de 10px usada no corpo da página. */
  size?: 'xs' | 'sm';
};

// ----------------------------------------------------------------------

/** `.sect`: 11px/700, tracking .08em, 12px abaixo. */
const SX_SM = {
  fontSize: 11,
  fontWeight: 700,
  lineHeight: 1.5,
  letterSpacing: '.08em',
  textTransform: 'uppercase',
  color: 'text.secondary',
  m: '0 0 12px',
} satisfies SystemStyleObject<Theme>;

/** `.navsub` no corpo: 10px/800, tracking .12em, 8px abaixo. */
const SX_XS = {
  fontSize: 10,
  fontWeight: 800,
  lineHeight: 1.5,
  letterSpacing: '.12em',
  textTransform: 'uppercase',
  color: 'text.secondary',
  mb: '8px',
} satisfies SystemStyleObject<Theme>;

// ----------------------------------------------------------------------

export function DsOverline({ children, size = 'sm' }: DsOverlineProps) {
  return <Box sx={size === 'sm' ? SX_SM : SX_XS}>{children}</Box>;
}
